import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useChangePasswordMutation } from '../../api/ProfileAPI';
import { RootState } from '../../Store';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';

/**
 * @author noone
 */
export default function AuftragSearch() {

    const auth = useSelector((state: RootState) => state.authSlice.auth);

    const [changePasswordAPI] = useChangePasswordMutation();
    const [oldPassword, setOldPassword] = useState<string>("");
    const [newPassword, setNewPassword] = useState<string>("");
    const [newPasswordRepeat, setNewPasswordRepeat] = useState<string>("");

    const handlePasswordChange = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        changePasswordAPI({ oldPassword: oldPassword, newPassword: newPassword, newPasswordRepeat: newPasswordRepeat })
            .unwrap()
            .then(() => {
                alert("Passwort geändert!");
            })
            .catch((error) => {
                alert("Fehler: " + error.data.text);
            });
    }

    useEffect(() => {
    }, []);

    return (
        <div className="container">

            <LandingpageHeader />

            <h3>Konto: {auth.user?.email}</h3>

            <h4 style={{ marginTop: "50px" }}>Passwort ändern:</h4>

            <form className='form-group' style={{ marginTop: "30px", width: "40%" }}>
                <label>Bisheriges Passwort:</label>
                <input className='form-control' type="password" placeholder="Bisheriges Passwort" onChange={(e) => setOldPassword(e.target.value)} />
                <br />
                <label>Neues Passwort:</label>
                <input className='form-control' type="password" placeholder="Neues Passwort" onChange={(e) => setNewPassword(e.target.value)} />
                <br />
                <label>Neues Passwort wiederholen:</label>
                <input className='form-control' type="password" placeholder="Neues Passwort wiederholen" onChange={(e) => setNewPasswordRepeat(e.target.value)} />
                <br />
                <button className='btn btn-primary' type="submit" onClick={handlePasswordChange}>Passwort ändern</button>
            </form>

            <Footer />
        </div>
    );

}